/**
 * @since 2024-05-04
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import LabelBox from "./LabelBox";

export default LabelBox;
